import { PageContainer } from '../../../shared/PageContainer';
import { useFeedback, ListAndDetail } from "@sis/react-library"
import ListIcon from '@mui/icons-material/List';
import { listAndDetailSamplesRoutes } from "../../ListAndDetailSamplesNavigation";
import { ListAndDetailSamplesPaginationPageInfo } from './ListAndDetailSamplesPaginationPageInfo';

interface ExampleDto {
    id: number;
    description: string;
}

const manyItems: ExampleDto[] = [];

for (let i = 1; i <= 428; i++) {
    manyItems.push({ id: i, description: `Item ${i}` })
}

export const ListAndDetailSamplesPaginationPage = () => {
    // This example is more for showing pagination and does not cater for delete.
    // See other examples of how the delete works
    const { showWarning } = useFeedback();

    const handleDelete = async () => {
        showWarning('No delete function available for this example, see other examples');
    }

    const listItemRender = (item: ExampleDto) => <>{item.description}</>;

    return (
        <PageContainer
            heading='List Samples - Pagination'
            icon={<ListIcon />}
            pageInfo={<ListAndDetailSamplesPaginationPageInfo />}
            wrapRightElementForMobile={false}
        >
            <ListAndDetail
                items={manyItems}
                keyValue={(item) => item.id.toString()}
                itemRender={listItemRender}
                searchFields={['description']}
                listUrl={listAndDetailSamplesRoutes.pagination}
                newUrl={listAndDetailSamplesRoutes.new}
                editUrl={listAndDetailSamplesRoutes.edit}
                deleteOptions={{
                    onDelete: handleDelete,
                    busyDeleting: false
                }}
                // The page size deafults to 50, but you can change it, uncomment the line below to see
                //pageSize={30}
            />
        </PageContainer>
    )
}
